import React, { useContext, useEffect, useRef, useState } from "react";
import NavButton from "./NavButton";
import { getApi, PatchApi } from "../../../Utility/network";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import styles from "./Step.module.css";
import PDFViewer from "../../../Components/PDFViewer/PDFViewer";
import Banner from "../../../Components/CertificateStep7/Banner";
import SidebarValues from "../../../Components/CertificateStep7/SidebarValues";
import ReviewChecklist from "../../../Components/CertificateStep7/ReviewChecklist";
import { consumCertEngText } from "../../../Utility/engLangObject";
import { consumCertGerText } from "../../../Utility/gerLangObject";

function Step7(props) {
  const scrollRef = useRef(null);
  const { state, setState } = useContext(AppContext);
  const { stepLanguage } = state;
  const [pdf, setPdf] = useState({ file: "" });
  const [submitData, setSubmitData] = useState({
    review: [],
    realistic_value: [],
    too_high_value: [],
    feedback_before_final_exhibition: [],
    notes: "",
  });
  const [initialLoad, setInitialLoad] = useState(false);
  const [response, setResponse] = useState(false);

  useEffect(() => {
    getPdfId();
    window.scroll(0, 0);
  }, []);

  const getPdfId = async () => {
    const postEnergy = await getApi(
      `energy_consumption/form/${state.form_id}/calculate_energy_consumption/`
    );
    if (postEnergy.status === 200) {
      const generate_pdf = await getApi(
        `records/${postEnergy?.data?.data?.id}/generate_energy_certificate/`
      );
      if (generate_pdf.status === 200 || generate_pdf.status === 201) {
        getData(postEnergy?.data?.data?.id);
      }
    }
  };

  const getData = async (pdfId) => {
    try {
      const responseData = await getApi(
        `/records/${pdfId}/generate_energy_certificate/`
      );
      setPdf(responseData?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (num, type) => {
    try {
      const payload = {
        page_no: 7,
        review_data: {
          realistic_value: submitData.realistic_value,
          too_high_value: submitData.too_high_value,
          feedback_before_final_exhibition: submitData.feedback_before_final_exhibition,
          notes: submitData.notes,
        },
      };
      await PatchApi(
        `/energy_consumption/form/${state.form_id}/additional_information/`,
        payload
      );
    } catch (e) {
      console.log(e);
    }

    if (type === "next") {
      setState((prev) => ({
        ...prev,
        page: 8,
        filledPage: prev.filledPage >= 8 ? prev.filledPage : 8,
      }));
    } else if (type === "save") {
      setResponse(true);
    } else {
      setState((prev) => ({ ...prev, page: prev.page - 1 }));
    }
  };

  const handleCheckboxChange = (name, checkedIds) => {
    if (name === "review") {
      setSubmitData((prev) => ({ ...prev, review: checkedIds }));
    } else if (name === "realistic_value") {
      setSubmitData((prev) => ({ ...prev, realistic_value: checkedIds }));
    } else if (name === "too_high_value") {
      setSubmitData((prev) => ({ ...prev, too_high_value: checkedIds }));
    } else if (name === "feedback_before_final_exhibition") {
      setSubmitData((prev) => ({
        ...prev,
        feedback_before_final_exhibition: checkedIds,
      }));
    }
  };

  const handleClick = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.log("scrollRef.current is null");
    }
  };

  const handleChangeNotes = (event) => {
    const { value } = event.target;
    setSubmitData((prev) => ({ ...prev, notes: value }));
  };

  useEffect(() => {
    if (initialLoad || !state?.form_id) return;
    const fetchSaved = async () => {
      try {
        const res = await getApi(
          `/energy_consumption/additional_information?energy_consumption=${state.form_id}&page_no=7`
        );
        const list = res?.data?.data || res?.data || [];
        const item = Array.isArray(list) ? list[0] : null;
        if (item?.review_data || item?.notes) {
          try {
            let parsed = item?.review_data ? item.review_data : (item?.notes ? item.notes : {});
            if (typeof parsed === 'string') {
              try {
                parsed = JSON.parse(parsed);
                // Handle double stringified JSON from Django JSONField
                if (typeof parsed === 'string') {
                  parsed = JSON.parse(parsed);
                }
              } catch (e) { }
            }
            setSubmitData((prev) => ({
              ...prev,
              realistic_value: Array.isArray(parsed?.realistic_value)
                ? parsed.realistic_value
                : [],
              too_high_value: Array.isArray(parsed?.too_high_value)
                ? parsed.too_high_value
                : [],
              feedback_before_final_exhibition: Array.isArray(
                parsed?.feedback_before_final_exhibition
              )
                ? parsed.feedback_before_final_exhibition
                : [],
              notes: parsed?.notes || (typeof parsed === "string" ? parsed : ""),
            }));
          } catch (e) {
            console.log(e);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        setInitialLoad(true);
      }
    };
    fetchSaved();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.form_id]);

  return (
    <div className={styles.step7}>
      <Banner styles={styles} language={stepLanguage} onContinue={handleClick} />

      <div className={styles.grid}>
        <div className={styles.panel}>
          {pdf && pdf.file !== "" && pdf?.file && (
            <div className={styles.doc}>
              <PDFViewer _url={pdf?.file} />
            </div>
          )}
          <div style={{ marginTop: "14px" }} className={styles.small}>
            {stepLanguage.energy_certificate_available_pdf_check_your_details}
          </div>
          <div className={styles.progress}>
            <div className={styles.bar}></div>
          </div>
          <div className={styles.small} style={{ marginTop: "6px" }}>
            {stepLanguage.energy_certificate_available_pdf_progress_bar}
          </div>
        </div>

        <div className={styles.panel}>
          <h3 style={{ margin: "0 0 10px" }}>
            {stepLanguage.energy_certificate_available_pdf_sidebar_section_1_title}
          </h3>
          <div className={styles.benefits}>
            <div className={styles.benefit}>
              <p>{stepLanguage.energy_certificate_available_pdf_sidebar_section_1_check_1}</p>
            </div>
            <div className={styles.benefit}>
              <p>{stepLanguage.energy_certificate_available_pdf_sidebar_section_1_check_2}</p>
            </div>
            <div className={styles.benefit}>
              <p>{stepLanguage.energy_certificate_available_pdf_sidebar_section_1_check_2}</p>
            </div>
            <div className={styles.benefit}>
              <p>{stepLanguage.energy_certificate_available_pdf_sidebar_section_1_check_3}</p>
            </div>
          </div>

          <hr
            style={{
              border: "none",
              borderTop: "1px solid #e5e7eb",
              margin: "18px 0",
            }}
          />

          <SidebarValues
            styles={styles}
            labels={{
              title: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_title,
              para1: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_1,
              para2: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_2,
              para3: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_3,
              info: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_info,
              feedbackLabel: stepLanguage.energy_certificate_available_pdf_sidebar_section_2_feedback,
            }}
            checkboxData={[
              {
                name: "realistic_value",
                data: [
                  {
                    title:
                      consumCertEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_1,
                    german_title:
                      consumCertGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_1,
                    id: 2,
                  },
                ],
                selectedValues: submitData.realistic_value,
              },
              {
                name: "too_high_value",
                data: [
                  {
                    title:
                      consumCertEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_2,
                    german_title:
                      consumCertGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_2,
                    id: 3,
                  },
                ],
                selectedValues: submitData.too_high_value,
              },
              {
                name: "feedback_before_final_exhibition",
                data: [
                  {
                    title:
                      consumCertEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_3,
                    german_title:
                      consumCertGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_3,
                    id: 4,
                  },
                ],
                selectedValues: submitData.feedback_before_final_exhibition,
              },
            ]}
            handleCheckboxChange={handleCheckboxChange}
            notes={submitData.notes}
            handleChangeNotes={handleChangeNotes}
          />
        </div>
      </div>

      <ReviewChecklist
        styles={styles}
        refProp={scrollRef}
        data={state.language === "en" ? data : dataGerman}
        selectedValues={submitData.review}
        handleCheckboxChange={handleCheckboxChange}
      />

      <NavButton
        handleSubmit={handleSubmit}
        disabled={submitData?.review?.length > 0 ? false : true}
        setResponse={setResponse}
        response={response}
      />
    </div>
  );
}

export default Step7;

const data = [
  {
    title: consumCertEngText.i_reviewed_entries,
    id: 1,
  },
];

const dataGerman = [
  {
    title: consumCertGerText.i_reviewed_entries,
    id: 1,
  },
];
